exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#chargeExplain {\n  font-size: 0.15rem;\n  padding: 0.07rem 0.13rem 0.25rem 0.13rem;\n}\n#chargeExplain h3 {\n  font-size: 0.15rem;\n  line-height: 1.7;\n  padding: 0.05rem 0;\n}\n#chargeExplain p {\n  line-height: 1.7;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/staticPage/chargeSecurityExplain/index.less
// module id = 278
// module chunks = 0